// Constants for Lob postcard dimensions
const TEMPLATE_WIDTH = '6.25in';
const TEMPLATE_HEIGHT = '4.25in';

export interface TextStyle {
  font?: string;
  alignment?: 'left' | 'center' | 'right';
  fontSize?: string;
}

export function createFrontTemplate(imageUrl: string): string {
  return `<html>
<head>
<meta charset="UTF-8">
<title>Lob.com Thank You 4x6 Postcard Template Front</title>
<style>
  *, *:before, *:after {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }

  body {
    width: 6.25in;
    height: 4.25in;
    margin: 0;
    padding: 0;
  }

  #safe-area {
    position: absolute;
    width: 5.875in;
    height: 3.875in;
    left: 0.1875in;
    top: 0.1875in;
    text-align: center;
  }

  #outer {
    width: 6.25in;
    height: 4.25in;
  }

  #inner {
    width: 5.5in;
    height: 3.5in;
    position: absolute;
    left: .375in;
    top: .375in;
  }

  img {
    max-width: 100%;
    height: auto;
    display: block;
  }

</style>
</head>

<body>
  <div id="outer">
    <div id="inner">
    </div>
  </div>

  <!-- do not put text outside of the safe area -->
  <div id="safe-area">
    <img src="${imageUrl}" alt="Card Front" />
  </div>

</body>
</html>`;
}

export function createBackTemplate(
  message: string,
  _occasion: string,  // renamed from title and marked as unused
  signatureUrl?: string,
  textStyle?: TextStyle
): string {
  const font = textStyle?.font || 'Lato';
  const alignment = textStyle?.alignment || 'left';
  const fontSize = textStyle?.fontSize || '0.122in';

  return `<html>
<head>
  <meta charset="UTF-8">
  <link href="https://fonts.googleapis.com/css?family=Lato:400" rel="stylesheet" type="text/css">
  <title>Lob.com Thank You 4x6 Postcard Template Back</title>
  <style>
    *, *:before, *:after {
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
    }
    body {
      border: 2px solid black;
      width: 6.25in;
      height: 4.25in;
      margin: 0;
      padding: 0;
      background-color: white;
    }
    .vertical {
      border-left: 6px solid black;
      height: 200px;
      position: absolute;
      left: 50%;
    }
    /* do not put text outside of the safe area */
    #safe-area {
      position: absolute;
      width: 5.875in;
      height: 3.875in;
      left: 0.1875in;
      top: 0.1875in;
    }
    #message-box {
      position: absolute;
      width: 2.4in;
      height: 3.52in;
      top: 0.125in;
      left: 0.05in;
      border-right: 4px solid black;
    }
    #message {
      position: absolute;
      width: 2.3in;
      height: 2.75in;
      top: .125in;
      left: .025in;
      font-family: '${font}';
      font-weight: 400;
      font-size: ${fontSize};
      text-align: ${alignment};
    }
    #signature {
      position: absolute;
      width: 2.3in;
      height: .75in;
      top: 2.875in;
      left: .025in;
      font-family: '${font}';
      font-weight: 400;
      font-size: ${fontSize};
    }
    #signature img {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }
    #address {
      position: absolute;
      width: 3.2835in;
      height: 2.375in;
      top: 1.5in;
      left: 2.504in;
      font-family: '${font}';
      font-weight: 400;
      font-size: ${fontSize};
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  </style>
</head>
<body>
  <div id="trim">
    <!--do not put text outside of the safe area-->
    <div id="safe-area">
      <div id="message-box">
        <div id="message">
          ${message}
        </div>
        ${signatureUrl ? `
        <div id="signature">
          <p>Best wishes,</p>
          <img src="${signatureUrl}" alt="Signature" />
        </div>
        ` : ''}
      </div>
      <div id="address">
        {{address}}
      </div>
    </div>
  </div>
</body>
</html>`;
}